import { defOp } from "./compile/emit.js";
const [invert, invert2, invert3, invert4] = defOp(
  ([o, a]) => `${o}=1/${a};`
);
export {
  invert,
  invert2,
  invert3,
  invert4
};
